import React, { ReactNode } from 'react';
import Dropdown from './Dropdown';
import TextButton from './inputs/TextButton';
import TransparentSpinner from './spinners/TransparentSpinner';
import { useTheme } from 'styled-components';
import Button from './inputs/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

interface Props {
  content?: ReactNode;
  label: ReactNode;
  asButton?: boolean;
  loading?: boolean;
  disabled?: boolean;
}

const DropdownMenu = ({
  label,
  content,
  asButton,
  loading,
  disabled,
}: Props) => {
  const theme = useTheme();
  const [isOpen, setIsOpen] = React.useState(false);
  return (
    <Dropdown content={isOpen && content} onLostFocus={() => setIsOpen(false)}>
      {asButton ? (
        <Button
          onClick={() => setIsOpen(!isOpen)}
          disabled={loading || disabled}
        >
          {loading ? (
            <TransparentSpinner color={theme.colors.foreground.button} small />
          ) : (
            label
          )}{' '}
          <FontAwesomeIcon icon={faChevronDown} />
        </Button>
      ) : (
        <TextButton
          unpadded
          style={{ border: '1px solid', padding: 5 }}
          title="Startar utanför hemområde"
          onClick={() => setIsOpen(!isOpen)}
        >
          {label}
        </TextButton>
      )}
    </Dropdown>
  );
};

export default DropdownMenu;
